import React, { useEffect, useState, useMemo, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";

import { Button, Dropdown, LoadingSpinner, Search, Switcher } from "pepsico-ds";
import { FetchLandingPageAction, FetchProcurementPageAction } from "../../redux/action/LandingPageAction";
import { getUserClaims } from "../../utils/auth/unified-auth";
import { useAuth } from "../../utils/auth/useAuth";
import CommodityPageHeader from "../../components/Header/CommodityPageHeader";
import Proc_Academy_Banner from '../../assets/Proc_Academy_Banner.svg';
import PepLogoBanner from '../../assets/PepLogoBanner.svg';
import { call7DaysNpsLogic } from "../../utils/utils";
import { useTour } from '../../routes/JoyrideProvide';
import "./ProcurementAcademy.scss";
import { urlConstants } from '../../constants/urlConstants';

export const CAPABILITY_ICONS = {
	"Strategic Procurement": "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM6.5 17.5L14.01 14.01L17.5 6.5L9.99 9.99L6.5 17.5ZM12 10.9C12.61 10.9 13.1 11.39 13.1 12C13.1 12.61 12.61 13.1 12 13.1C11.39 13.1 10.9 12.61 10.9 12C10.9 11.39 11.39 10.9 12 10.9Z",
	"Commercial & Financial Excellence": "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM12.31 11.14C10.54 10.69 9.97 10.2 9.97 9.47C9.97 8.63 10.76 8.04 12.07 8.04C13.45 8.04 13.97 8.7 14.01 9.68H15.72C15.67 8.34 14.85 7.11 13.23 6.71V5H10.9V6.69C9.39 7.01 8.18 7.99 8.18 9.5C8.18 11.29 9.67 12.19 11.84 12.71C13.79 13.17 14.18 13.86 14.18 14.58C14.18 15.11 13.79 15.97 12.08 15.97C10.48 15.97 9.85 15.25 9.76 14.33H8.04C8.14 16.03 9.4 16.99 10.9 17.3V19H13.24V17.33C14.76 17.04 15.96 16.17 15.97 14.56C15.96 12.36 14.07 11.6 12.31 11.14Z",
	"Supplier & Innovation Management": "M9 21C9 21.55 9.45 22 10 22H14C14.55 22 15 21.55 15 21V20H9V21ZM12 2C8.14 2 5 5.14 5 9C5 11.38 6.19 13.47 8 14.74V17C8 17.55 8.45 18 9 18H15C15.55 18 16 17.55 16 17V14.74C17.81 13.47 19 11.38 19 9C19 5.14 15.86 2 12 2ZM14.85 13.1L14 13.7V16H10V13.7L9.15 13.1C7.8 12.16 7 10.63 7 9C7 6.24 9.24 4 12 4C14.76 4 17 6.24 17 9C17 10.63 16.2 12.16 14.85 13.1Z",
	"Risk, Resilience & Sustainability": "M6.04994 8.05C3.31994 10.78 3.31994 15.22 6.04994 17.95C7.41994 19.32 9.20994 20 10.9999 20C12.7899 20 14.5799 19.32 15.9499 17.95C19.4299 14.47 19.9999 4 19.9999 4C19.9999 4 9.52994 4.57 6.04994 8.05ZM14.5399 16.54C13.5899 17.48 12.3399 18 10.9999 18C10.1099 18 9.26994 17.75 8.51994 17.32C9.43994 14.44 11.1399 11.91 13.3999 10C10.7699 11.36 8.55994 13.46 7.02994 16C5.54994 14.04 5.67994 11.25 7.46994 9.46C9.20994 7.72 14.0399 6.65 17.7999 6.2C17.3499 9.96 16.2799 14.79 14.5399 16.54Z",
	"Digital Literacy": "M20 18C21.1 18 21.99 17.1 21.99 16L22 5C22 3.9 21.1 3 20 3H4C2.9 3 2 3.9 2 5V16C2 17.1 2.9 18 4 18H0C0 19.1 0.9 20 2 20H22C23.1 20 24 19.1 24 18H20ZM4 5H20V16H4V5ZM12 19C11.45 19 11 18.55 11 18C11 17.45 11.45 17 12 17C12.55 17 13 17.45 13 18C13 18.55 12.55 19 12 19Z",
	"Operational Excellence": "M19.43 12.98C19.47 12.66 19.5 12.34 19.5 12C19.5 11.66 19.47 11.34 19.43 11.02L21.54 9.37C21.73 9.22 21.78 8.95 21.66 8.73L19.66 5.27C19.57 5.11 19.4 5.02 19.22 5.02C19.16 5.02 19.1 5.03 19.05 5.05L16.56 6.05C16.04 5.65 15.48 5.32 14.87 5.07L14.49 2.42C14.46 2.18 14.25 2 14 2H9.99996C9.74996 2 9.53996 2.18 9.50996 2.42L9.12996 5.07C8.51996 5.32 7.95996 5.66 7.43996 6.05L4.94996 5.05C4.88996 5.03 4.82996 5.02 4.76996 5.02C4.59996 5.02 4.42996 5.11 4.33996 5.27L2.33996 8.73C2.20996 8.95 2.26996 9.22 2.45996 9.37L4.56996 11.02C4.52996 11.34 4.49996 11.67 4.56996 12.98L2.45996 14.63C2.26996 14.78 2.21996 15.05 2.33996 15.27L4.33996 18.73C4.42996 18.89 4.59996 18.98 4.77996 18.98C4.83996 18.98 4.89996 18.97 4.94996 18.95L7.43996 17.95C7.95996 18.35 8.51996 18.68 9.12996 18.93L9.50996 21.58C9.53996 21.82 9.74996 22 9.99996 22H14C14.25 22 14.46 21.82 14.49 21.58L14.87 18.93C15.48 18.68 16.04 18.34 16.56 17.95L19.05 18.95C19.11 18.97 19.17 18.98 19.23 18.98C19.4 18.98 19.57 18.89 19.66 18.73L21.66 15.27C21.78 15.05 21.73 14.78 21.54 14.63L19.43 12.98ZM17.45 11.27C17.49 11.58 17.5 11.79 17.5 12C17.5 12.21 17.48 12.43 17.45 12.73L17.31 13.86L18.2 14.56L19.28 15.4L18.58 16.61L17.31 16.1L16.27 15.68L15.37 16.36C14.94 16.68 14.53 16.92 14.12 17.09L13.06 17.52L12.9 18.65L12.7 20H11.3L10.95 17.52L9.88996 17.09C9.45996 16.91 9.05996 16.68 8.65996 16.38L7.74996 15.68L6.68996 16.11L5.41996 16.62L4.71996 15.41L5.79996 14.57L6.68996 13.87L6.54996 12.74C6.51996 12.43 6.49996 12.2 6.54996 11.27L6.68996 10.14L5.79996 9.44L4.71996 8.6L5.41996 7.39L6.68996 7.9L7.72996 8.32L8.62996 7.64C9.05996 7.32 9.46996 7.08 9.87996 6.91L10.94 6.48L11.1 5.35L11.3 4H12.69L13.04 6.48L14.1 6.91C14.53 7.09 14.93 7.32 15.33 7.62L16.24 8.32L17.3 7.89L18.57 7.38L19.27 8.59L18.2 9.44L17.31 10.14L17.45 11.27ZM12 8C9.78996 8 7.99996 9.79 7.99996 12C7.99996 14.21 9.78996 16 12 16C14.21 16 16 14.21 16 12C16 9.79 14.21 8 12 8ZM12 14C10.9 14 9.99996 13.1 9.99996 12C9.99996 10.9 10.9 10 12 10C13.1 10 14 10.9 14 14Z",
	"Specialized Category Trainings": "M12 2L6.5 11H17.5L12 2ZM12 5.84L13.93 9H10.06L12 5.84ZM17.5 13C15.01 13 13 15.01 13 17.5C13 19.99 15.01 22 17.5 22C19.99 22 22 19.99 22 17.5C22 15.01 19.99 13 17.5 13ZM17.5 20C16.12 20 15 18.88 15 17.5C15 16.12 16.12 15 17.5 15C18.88 15 20 16.12 20 17.5C20 18.88 18.88 20 17.5 20ZM3 21.5H11V13.5H3V21.5ZM5 15.5H9V19.5H5V15.5Z",
	"Core Skills Training": "M4 6H2V20C2 21.1 2.9 22 4 22H18V20H4V6ZM20 2H8C6.9 2 6 2.9 6 4V16C6 17.1 6.9 18 8 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H8V4H20V16ZM10 9H18V11H10V9ZM10 12H14V14H10V12ZM10 6H18V8H10V6Z",
	"Onboarding Trainings": "M15.5 13.5C15.5 15.5 13 17 13 18.5H11C11 17 8.5 15.5 8.5 13.5C8.5 11.57 10.07 10 12 10C13.93 10 15.5 11.57 15.5 13.5ZM13 19.5H11V21H13V19.5ZM19 13C19 14.68 18.41 16.21 17.42 17.42L18.84 18.84C20.18 17.27 21 15.23 21 13C21 10.26 19.77 7.81 17.84 6.16L16.42 7.58C17.99 8.86 19 10.82 19 13ZM16 5L12 1V4C7.03 4 3 8.03 3 13C3 15.23 3.82 17.27 5.16 18.84L6.58 17.42C5.59 16.21 5 14.68 5 13C5 9.14 8.14 6 12 6V9L16 5Z"
};

const getSearchHierarchyLabel = (item) => {
	const categories = item?.type === "L1"
		? [item.l1Category]
		: item?.type === "L2"
			? [item.l1Category, item.l2Category]
			: [item.l1Category, item.l2Category, item.l3Category];
	const hierarchy = categories.filter(Boolean).join(" - ");
	return hierarchy && hierarchy !== item?.name
		? `${item?.name || ""} - ${hierarchy}`
		: item?.name || hierarchy || "";
};

const NON_L1_SEARCH_ICON = (
	<svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
		<path d="M12.6667 12.6667H3.33333V3.33333H8V2H3.33333C2.59333 2 2 2.6 2 3.33333V12.6667C2 13.4 2.59333 14 3.33333 14H12.6667C13.4 14 14 13.4 14 12.6667V8H12.6667V12.6667ZM9.33333 2V3.33333H11.7267L5.17333 9.88667L6.11333 10.8267L12.6667 4.27333V6.66667H14V2H9.33333Z" fill="#2D2D2D" />
	</svg>
);

const NO_SEARCH_RESULTS_ICON = (
	<svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
		<path d="M6.66 0C2.98 0 0 2.98667 0 6.66667C0 10.3467 2.98 13.3333 6.66 13.3333C10.3467 13.3333 13.3333 10.3467 13.3333 6.66667C13.3333 2.98667 10.3467 0 6.66 0ZM6.66667 12C3.72 12 1.33333 9.61333 1.33333 6.66667C1.33333 3.72 3.72 1.33333 6.66667 1.33333C9.61333 1.33333 12 3.72 12 6.66667C12 9.61333 9.61333 12 6.66667 12ZM7 3.33333H6V7.33333L9.5 9.43333L10 8.61333L7 6.83333V3.33333Z" fill="#2D2D2D" />
	</svg>
);

const normalizeProcurementRoute = (url = "") => {
	return url.replace(/^\/overview(?=\/procurement-capabilities(?:\/|$))/, "");
};

const toSearchText = (value) => String(value ?? "");

function ProcurementAcademy() {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const { authState } = useAuth();
	const [userInfo, setUserInfo] = useState({});
	const [isDataLoading, setIsDataLoading] = useState(true);
	const [isUserDataFetched, setIsUserDataFetched] = useState(false);
	const [activeTier, setActiveTier] = useState("allLearnings");
	const location = useLocation();
	const [searchQuery, setSearchQuery] = useState(location?.state?.searchQuery || "");
	const [highlightCardId, setHighlightCardId] = useState(null);
	const [highlightCardReady, setHighlightCardReady] = useState(false);
	const [isHighlightBackdropVisible, setIsHighlightBackdropVisible] = useState(false);
	const cardRefs = useRef({});
	const capabilitiesSectionRef = useRef(null);
	const appliedHighlightLocationKey = useRef(null);
	const [isSearchFocused, setIsSearchFocused] = useState(false);
	const [searchIndex, setSearchIndex] = useState([]);
	const procurementRequestStarted = useRef(false);

	const { startTour } = useTour();

	useEffect(() => {
		const isSearchNavigation = Boolean(
			location.state?.searchQuery && location.state?.highlightCardId
		);
		if (isSearchNavigation) return;

		setSearchQuery("");
		setHighlightCardId(null);
		setHighlightCardReady(false);
		setIsHighlightBackdropVisible(false);
	}, [location.key, location.state]);

	useEffect(() => {
		if (toSearchText(searchQuery).trim()) return;

		setHighlightCardId(null);
		setHighlightCardReady(false);
		setIsHighlightBackdropVisible(false);
	}, [searchQuery]);

	useEffect(() => {
		async function fetchUserInfo() {
			const user = await getUserClaims();
			if (user) {
				setUserInfo(user);
				dispatch(FetchLandingPageAction(user));
				setIsUserDataFetched(true)
			}
		}
		setIsDataLoading(true);
		fetchUserInfo();
	}, [dispatch]);

	useEffect(() => {
		dispatch({
			type: 'RESET_PROC_PAGE_ACTION',
			payload: "RESET_PROC_PAGE_ACTION"
		});
		setIsDataLoading(true);
		procurementRequestStarted.current = false;
	}, [dispatch]);

	useEffect(() => {
		return () => {
			dispatch({
				type: 'RESET_PROC_PAGE_ACTION',
				payload: "RESET_PROC_PAGE_ACTION"
			});
		};
	}, [dispatch]);

	const userData = useSelector((state) => state.getLandingPageReducer);
	const cardData = useSelector((state) => state.getProcurementPageReducer);
	useEffect(() => {
		setSearchIndex(Array.isArray(cardData?.searchIndex) ? cardData.searchIndex : []);
	}, [cardData?.searchIndex]);
	const pageDetails = cardData?.procurementLearning?.pageDetails || {};

	/* istanbul ignore next */
	useEffect(() => {
		if (procurementRequestStarted.current && cardData && cardData?.type === "SUCCESS_PROC_PAGE_ACTION") {
			setIsDataLoading(false);
		}
	}, [cardData]);

	/* istanbul ignore next */
	useEffect(() => {
		if (isUserDataFetched && userData && userData?.type === "SUCCESS_LANDING_PAGE_ACTION") {
			call7DaysNpsLogic(dispatch, userData);
			setIsDataLoading(true);
			procurementRequestStarted.current = true;
			Promise.resolve(dispatch(FetchProcurementPageAction(1)))
				.then(() => setIsDataLoading(false));
		}
	}, [dispatch, isUserDataFetched, userData]);

	const capabilities = useMemo(() => Array.isArray(cardData?.courses)
		? cardData.courses
			.filter((card) => {
				const topics = Number(card?.topicCount || 0);
				const modules = Number(card?.moduleCount || 0);
				return topics + modules > 0;
			})
			.map((card, index) => ({
				id: card.route || `procurement-academy-${index}`,
				title: card.name || "Procurement Learning",
				description: card.desc || "",
				tag: card.name === "Digital Literacy"
					? `${card.moduleCount || 0} ${Number(card?.moduleCount || 0) === 1 ? 'topic' : 'topics'}`
					: Number(card?.topicCount || 0) > 0
						? `${card.topicCount} ${Number(card?.topicCount || 0) === 1 ? 'topic' : 'topics'}`
						: `${card.moduleCount || 0} ${Number(card?.moduleCount || 0) === 1 ? 'module' : 'modules'}`,
				url: normalizeProcurementRoute(card.route),
				buttonText: card.name === "Digital Literacy" || Number(card?.moduleCount || 0) === 0
					? 'Explore Capability'
					: 'Explore Modules',
				icon: CAPABILITY_ICONS[card.name] ? (
					<svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
						<path d={CAPABILITY_ICONS[card.name]} fill="#2D2D2D" />
					</svg>
				) : null,
			}))
		: [], [cardData?.courses]);
	const searchResults = useMemo(() => {
		const query = toSearchText(searchQuery).trim().toLowerCase();
		if (!query) return [];

		return (searchIndex || [])
			.filter((item) => {
				if (!item) return false;
				const q = query;
				return (
					toSearchText(item.name).toLowerCase().includes(q)
				);
			})
			.map((item) => ({ ...item, searchLabel: getSearchHierarchyLabel(item) }));
	}, [searchQuery, searchIndex]);

	const normalizedSearchQuery = toSearchText(searchQuery).trim();
	const displayedSearchResults = normalizedSearchQuery && searchResults.length === 0
		? [{
			id: "no-search-results",
			searchLabel: `${normalizedSearchQuery} - No matching content found. Try searching by Capability, Topic, or Module Title.`,
			value: { isNoSearchResults: true },
			icon: NO_SEARCH_RESULTS_ICON,
		}]
		: searchResults;

	// Filter capabilities returned by the procurement-academy API.
	// Do not change cards UI when searching — always show capabilities (respecting tier)
	const filteredCapabilities = useMemo(() => {
		return capabilities.filter((cap) => {
			const matchesTier = activeTier === "allLearnings" ? true : cap.tier === activeTier;
			return matchesTier;
		});
	}, [capabilities, activeTier]);

	const handleNavigate = (url, cap = null) => {
		if (!url) {
			return;
		}
		setSearchQuery("");

		if (url.startsWith("http://") || url.startsWith("https://")) {
			window.open(url, "_blank");
			return;
		}

		const destination = normalizeProcurementRoute(url);

		navigate(destination, {
			state: cap
				? {
					capability: {
						id: cap.id,
						title: cap.title,
						description: cap.description,
						tier: cap.tier,
						tag: cap.tag,
						tagTheme: cap.tagTheme,
						url: cap.url,
						route: cap.url
					}
				}
				: undefined
		});
	};

	const handleSearchResult = (option) => {
		const result = option?.value || option;
		const selectedSearchQuery = result?.name || option?.label || "";
		setSearchQuery(selectedSearchQuery);
		if (result?.isNoSearchResults) {
			return;
		}
		// External URLs still open in a new tab
		if (result?.route && (result.route.startsWith('http://') || result.route.startsWith('https://'))) {
			window.open(result.route, '_blank');
			return;
		}
		if (result?.route) {
			const preservedSearchQuery = selectedSearchQuery || toSearchText(searchQuery).trim();
			const dest = normalizeProcurementRoute(result.route);
			if (result.type === "CARD") {
				navigate(dest, {
					state: {
						highlightCardId: dest,
						highlightCardName: result.name,
						searchQuery: preservedSearchQuery,
					},
				});
				return;
			}
			// Highlight only when the selected result belongs to the current page.
			// Child routes must navigate to their own page first.
			if (dest === location.pathname) {
				// Try to resolve a more specific capability/card on the current page that matches the selected result
				let targetId = dest;
				try {
					const needle = (result.name || result.l1Category || result.l2Category || "").toLowerCase();
					const match = (capabilities || []).find(c => (c.title || "").toLowerCase() === needle || (c.title || "").toLowerCase().includes(needle));
					if (match) targetId = match.url || match.id || dest;
				} catch (e) {
					// ignore
				}
				restartHighlight(targetId);
				return;
			}
			// navigate and ask target page to highlight
			navigate(dest, {
				state: {
					highlightCardId: dest,
					highlightCardName: result.name,
					searchQuery: preservedSearchQuery,
				},
			});
		}
	};

	useEffect(() => {
		if (location?.state?.highlightCardId && appliedHighlightLocationKey.current !== location.key) {
			appliedHighlightLocationKey.current = location.key;
			setHighlightCardId(location.state.highlightCardId);
		}
	}, [location?.key, location?.state?.highlightCardId]);

	useEffect(() => {
		const highlightName = location?.state?.highlightCardName?.trim().toLowerCase();
		if (!highlightName || !capabilities.length) return;

		const matchingCapability = capabilities.find((cap) => cap.title?.trim().toLowerCase() === highlightName);
		if (matchingCapability) {
			setHighlightCardId(matchingCapability.url || matchingCapability.id);
		}
	}, [capabilities, location?.state?.highlightCardName]);

	useEffect(() => {
		setHighlightCardReady(false);
		if (!highlightCardId) {
			setIsHighlightBackdropVisible(false);
			return;
		}
		const el = cardRefs.current[highlightCardId];
		if (el && typeof el.scrollIntoView === 'function') {
			setTimeout(() => el.scrollIntoView({ behavior: 'smooth', block: 'center' }), 100);
		}
	}, [highlightCardId, location.pathname, location.state, navigate]);

	const restartHighlight = (targetId) => {
		setHighlightCardReady(false);
		setIsHighlightBackdropVisible(false);
		setHighlightCardId(targetId);
		requestAnimationFrame(() => {
			setHighlightCardReady(true);
		});
	};

	if (authState?.isAuthenticated) {
		return (
			<>
				{/* Hero Banner Section */}
				<CommodityPageHeader
					header={"Procurement Capabilities"}
					subtext={"Continue building your skills one step at a time with focused courses to support your growth in procurement."}
					image={Proc_Academy_Banner}
				/>

				<div className="pa-overview-banner" style={{ marginBottom:"16px" }}>
					<div className="pa-overview-banner-left">
						<span className="pa-overview-banner-icon" aria-hidden="true">
							<img src={PepLogoBanner} alt="" width="49" height="49" />
						</span>
						<div className="pa-overview-banner-text">
							<div className="pa-overview-banner-title">Procurement Capabilities Overview</div>
							<div className="pa-overview-banner-subtext">Core Procurement Capabilities and Specialists Capabilities learning modules with courses of various proficiency levels courses featured</div>
						</div>
					</div>
					<Button
						className="pa-overview-banner-button"
						text="Know more"
						iconTrailing="arrow_forward"
						size="large"
						variant="primary"
						onClick={function clickButton() {
							window.open(urlConstants?.procAcademyPpt, "_blank", "noopener")
						}}
					/>
				</div>

				<div className="procurement-academy-slot">
					{highlightCardId && isHighlightBackdropVisible && (
						<div
							className="pa-highlight-backdrop"
							aria-hidden="true"
						/>
					)}

					{isDataLoading ? (
						<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: 300 }}>
							<LoadingSpinner size={{ height: '80px', width: '80px' }} />
						</div>
					) : (
						<>
							<section className="pa-capabilities-section" ref={capabilitiesSectionRef}>
								<div className="pa-section-header">
									{/* <div className="pa-switcher" role="group" aria-label="Learning type"> */}
									<Switcher
										items={[
											{ label: 'All Learnings', style: { pointerEvents: 'auto' } },
											{ label: 'Tools', disabled: true, style: { color: '#c2bcbc', pointerEvents: 'none' } },
											{ label: 'Webinars', disabled: true, style: { color: '#c2bcbc', pointerEvents: 'none' } }
										]}
										selectedItemIndex={activeTier === 'allLearnings' ? 0 : activeTier === 'tools' ? 1 : 2}
										onUpdate={(index) => {
											const map = ['allLearnings', 'tools', 'webinars'];
											setActiveTier(map[index] || 'allLearnings');
										}}
									/>
									{/* </div> */}
									<Search
										className="pa-search-control"
										style={{ borderRadius: "48px" }}
										// delay={300}
										isAutoComplete
										isClearable
										focus={isSearchFocused}
										menuPosition="bottom-right"
										onClear={() => {
											setSearchQuery("");
											setIsSearchFocused(false);
											setHighlightCardId(null);
											setHighlightCardReady(false);
											setIsHighlightBackdropVisible(false);
											navigate(location.pathname, { replace: true, state: null });
										}}
										onSearch={() => setIsSearchFocused(true)}
										onSelectOption={handleSearchResult}
										onUpdate={(value) => {
											setSearchQuery(toSearchText(value));
											setIsSearchFocused(true);
										}}
										placeholderText="Search..."
										searchTerm={searchQuery}
										size="medium"
										suggestions={displayedSearchResults.map((result) => ({
											id: result.route,
											label: result.value?.isNoSearchResults
												? result.searchLabel
												: result.name,
											value: result,
											icon: result.value?.isNoSearchResults
												? NO_SEARCH_RESULTS_ICON
												: result.type === "CARD" ? NON_L1_SEARCH_ICON : undefined,
										}))}
										limitSuggestions={displayedSearchResults.length}
										type="global"
									/>
								</div>


								{/* Capabilities Grid */}
								<div className="pa-cards-grid">
									{filteredCapabilities.map((cap) => (
										<div
											key={cap.id}
											ref={(el) => {
												const cardId = cap.url || cap.id;
												cardRefs.current[cardId] = el;
												if (el && cardId === highlightCardId) {
													setHighlightCardReady(true);
												}
											}}
											onAnimationStart={(event) => {
												if (event.animationName === 'floating-card-pulse') {
													setIsHighlightBackdropVisible(true);
												}
											}}
											onAnimationEnd={(event) => {
												if (event.animationName === 'floating-card-pulse') {
													setIsHighlightBackdropVisible(false);
												}
											}}
											className={`pa-capability-card ${highlightCardReady && (cap.url || cap.id) === highlightCardId ? 'pa-card-floating-highlight' : ''}`}>
											{ }
											<div className="pa-card-header">
												<div className="pa-card-leading-icon">
													{cap.icon}
												</div>
												<div className="pa-card-title" title={cap.title}>
													{cap.title}
												</div>
											</div>

											<div className="pa-card-body">
												<p className="pa-card-description">
													{cap.description}
												</p>
												{/* <div className="pa-card-tag-anchor">
													<span className={`pa-tag ${cap.tagTheme === "blue" ? "theme-blue" : ""}`}>
														<span className="pa-tag-value">{cap.tag}</span>
													</span>
												</div> */}
											</div>

											<div className="pa-card-button-row">
												<button
													type="button"
													className="pa-explore-button"
													onClick={() => handleNavigate(cap.url, cap)}
												>
													<span className="pa-explore-button-text">{cap.buttonText || 'Explore Capability'}</span>
													<span className="pa-explore-button-icon">
														<svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
															<path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z" />
														</svg>
													</span>
												</button>
											</div>
										</div>
									))}
								</div>
							</section>
						</>
					)}
				</div>
			</>
		);
	}
	return null;
}

export default ProcurementAcademy;
